import gql from "graphql-tag";
const UserSettingsV2Fields = gql`
  fragment UserSettingsV2Fields on UserSettingsV2 {
    enabledIssuerPageBoxes {
      acoes
      fiis
      stocks
    }
    financialsTable {
      fullBleed
      indicatorDataSource
      sortDirection
      statementType
      textAlignment
    }
    hasClosedMarch24PerpetualBlackPopUp
    id
    language
    objectId
    ownerId
    screener {
      bookmarkedIndicators
    }
    theme
  }
`;
export default UserSettingsV2Fields;
